import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { activityLogApi } from '../../../../../../../api/activityLog/activityLogApi';
import { IDriverDocumentStatus } from '../../../../../../../api/activityLog/interfaces';
import { APIStatus, APIStatusOK } from '../../../../../../../api/apiError';

export const fetchDriverDocumentStatus = createAsyncThunk(
    'fetchDriverDocumentStatus',
    async (_, { rejectWithValue }) => {
        try {
            return await activityLogApi.fetchDriverDocumentStatus();
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);

export interface IDriverDocumentStatusInitialState {
    loading: boolean;
    driverDocumentStatusList: IDriverDocumentStatus[];
    status: APIStatus;
}

const initialState: IDriverDocumentStatusInitialState = {
    loading: false,
    driverDocumentStatusList: [],
    status: APIStatusOK,
};

export const driverDocumentStatusSlice = createSlice({
    name: 'driverDocumentStatus',
    initialState,
    reducers: {
        setDriverDocumentStatusList: (
            state,
            action: PayloadAction<IDriverDocumentStatus[]>,
        ) => {
            state.driverDocumentStatusList = action.payload;
        },
        resetDriverDocumentStatusList: state => {
            state.driverDocumentStatusList = [];
            state.loading = false;
            state.status = APIStatusOK;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchDriverDocumentStatus.pending, state => {
            state.loading = true;
            state.driverDocumentStatusList = [];
        });
        builder.addCase(
            fetchDriverDocumentStatus.fulfilled,
            (state, action) => {
                state.loading = false;
                state.driverDocumentStatusList = action.payload || [];
            },
        );
        builder.addCase(fetchDriverDocumentStatus.rejected, (state, action) => {
            state.loading = false;
            state.status = action.payload as APIStatus;
            state.driverDocumentStatusList = [];
        });
    },
});

export const { setDriverDocumentStatusList, resetDriverDocumentStatusList } =
    driverDocumentStatusSlice.actions;

const DriverDocumentStatusReducer = driverDocumentStatusSlice.reducer;
export default DriverDocumentStatusReducer;
